import React from "react";
import "./PasswordReq.css";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ContentForm from "../../UI/ContentForm/ContentForm";
import Input from "../../UI/Input/Input";
import Button from "../../UI/Button/Button";
import Fade from "react-reveal/Fade";
import { updateObject, checkValidity } from "../../../shared/utility";
import FetchData from "../../../shared/fetchData";
import { toast } from "react-toastify";
const PasswordReq = (props) => {
  const [passwordTypes, setPasswordTypes] = React.useState({
    value: "G",
    label: "رمز عمومی",
  });
  const [passwordType, setPasswordType] = React.useState("G");
  const [hasPayment, setHasPayment] = React.useState(false);
  const [showDetails, setShowDetails] = React.useState(false);
  const [changeForm, setChangeForm] = React.useState(false);
  const [password, setPassword] = React.useState({
    amount: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "مبلغ",
        unit: "ریال",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
  });
  const putPasswordType = (event, passType) => {
    setPasswordType(passType);
    setShowDetails(true);
  };
  const changeHasPayment = (event) => {
    setHasPayment(event.target.checked);
  };
  const inputChangedHandler = (event, controlName) => {
    let val =
      controlName == "amount"
        ? event.target.value.toString().replace(/[^0-9]/g, "")
        : event.target.value;
    let value =
      controlName == "amount"
        ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : val;
    const updatedControls = updateObject(password, {
      [controlName]: updateObject(password[controlName], {
        value: value,
        valid: checkValidity(
          event.target.value,
          password[controlName].validation
        ),
      }),
    });
    setPassword(updatedControls);
  };
  const toggleShowDetail = (event, value) => {
    setShowDetails(value);
  };
  const passwordReqSubmit = (event) => {
    let valid = true;
    const pass = password;
    if (
      hasPayment &&
      (password.amount.value == null || password.amount.value == "")
    ) {
      valid = false;
    }
    if (!valid) {
      pass.amount.valid = false;
      setPassword(pass);
      if (changeForm) {
        setChangeForm(false);
      } else {
        setChangeForm(true);
      }
    } else {
      var raw = JSON.stringify({
        orderNumber: props.orderNumber,
        amount:
          password.amount.value != ""
            ? password.amount.value.toString().replace(/[^0-9]/g, "")
            : "",
        version: "mtpx001",
      });
      var url = "management/api/v1/passwords/newInputPassword";
      if (passwordType === "O") {
        url = "management/api/v1/passwords/newOutputPassword";
      } else if (passwordType === "G") {
        url = "management/api/v1/passwords/newGeneralPassword";
      } else if (passwordType === "G") {
        url = "management/api/v1/passwords/newSpecialPassword";
      }
      FetchData(raw, url)
        .then((response) => response.json())
        .then((result) => {
          if (result.status == "0") {
            toast.success("عملیات با موفقیت انجام شد");
            props.closeModal();
          } else if (result.message == "INVALID_STATE") {
            toast.error("وضعیت سفارش صحیح نیست");
          }
        })
        .catch((error) => console.log(error));
    }
  };
  const formElementsArray = [];
  for (let key in password) {
    formElementsArray.push({
      id: key,
      config: password[key],
    });
  }
  let form = formElementsArray.map((formElement) => {
    return (
      <Input
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        placeholder={formElement.config.placeholder}
        errorMessage={formElement.config.errorMessage}
        col="12 mt-3"
        changed={(event) => inputChangedHandler(event, formElement.id)}
      />
    );
  });

  return (
    <div className="pass-req-container mb-5">
      <ContentForm headetText="نوع رمز">
        <Fade duration={200} left cascade>
          <div className="col-12 mr-4 full-small">
            <label className="container role-text">
              {passwordTypes.label}
              <input
                type="checkbox"
                checked={true}
                value="ENVELOPE"
                id="flexCheckDefault"
              />
              <span className="checkmark"></span>
            </label>
          </div>
          <div className="col-6 mt-3">
            <FormControlLabel
              control={
                <Checkbox checked={hasPayment} onChange={changeHasPayment} />
              }
              label="نیاز به پرداخت دارد؟"
            />
          </div>
          {hasPayment ? form : ""}
          <div className="col-12 mt-3">
            <div className="row justify-content-center">
              <div className="col-6 text-center">
                <Button
                  btnType="Success"
                  clicked={(event) => passwordReqSubmit(event)}
                >
                  ثبت
                </Button>
              </div>
            </div>
          </div>
        </Fade>
      </ContentForm>
    </div>
  );
};

export default PasswordReq;
